module.exports = __webpack_public_path__ + "static/img/teaser_iac2024.10f1a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser_iac2024.png
// module id = EBmW
// module chunks = 0